import { IconButton, List, ListItem, SvgIcon, Tooltip } from '@mui/material';
import { LogOut, SwitchHorizontal01 } from '../../../../../assets';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { UserContext } from '../../../../shared/useUser';
import { DrawerNavItem } from '../../interfaces/DrawerNavItem';
import { NavItem } from '../NavItem';

interface UserNavItemsListProps {
  variant?: 'default' | 'iconColumn',
  logOutOnClick: () => void,
  switchStoreOnClick: () => void;
}

export const UserNavItemsList = ({ variant, logOutOnClick, switchStoreOnClick }: UserNavItemsListProps) => {
  const { t } = useTranslation('drawer');
  const { user, franchises } = useContext(UserContext);

  // Show "switch store" when the user has access to more than one store,
  // or when the user has access to more than one franchise.
  const canSwitchStore = (user?.stores ?? []).length > 1 || (franchises ?? []).length > 1;

  const userNavItems: DrawerNavItem[] = [
    {
      canRender: true,
      translationKey: 'switchStore',
      icon: <SwitchHorizontal01 />,
      onClick: switchStoreOnClick,
      tooltipText: 'selectStore',
    },
    {
      canRender: true,
      translationKey: 'logOut',
      icon: <LogOut />,
      onClick: logOutOnClick,
      tooltipText: 'logOut',
    },
  ];

  const renderIconColumn = (item: DrawerNavItem) => (
    <ListItem key={item.translationKey}
      sx={{ 
        padding:0, 
        margin:0,
      }}
    >
      <IconButton onClick={item.onClick}
        sx={{ color: 'common.white' }}
      >
        <Tooltip title={t(`${item.tooltipText}`)}>
          <SvgIcon
            key={`user-nav-item-${item.translationKey}`}
            sx={{
              fontSize: 16,
              cursor: 'pointer',
            }}>
            {item.icon}
          </SvgIcon>
        </Tooltip>
      </IconButton>
    </ListItem>);

  const renderItem = (item: DrawerNavItem) => {
    switch (variant) {
    case 'iconColumn':
      return renderIconColumn(item);
    case 'default':
    default:
      return <NavItem item={item}
        onClick={item.onClick}/>;
    }
  };

  return (
    <List sx={{
      marginTop:'16px',
      marginBottom:'16px',
      padding:'0',
    }}
    >
      {canSwitchStore ? userNavItems.map(renderItem) : userNavItems.filter(item => item.translationKey !== 'switchStore').map(renderItem)}
    </List>);
};